import McLineChart from './McLineChart';

export default McLineChart;
